module.exports = __webpack_public_path__ + "4b1302adf976803edcc07235b6572d78.jpg";